import _ from 'lodash'

export const Mutations = {
    deleteInvoiceById(state, id){
        let invoice = _.filter(state.items, function(i) {
            return i.id == id;
        });
        let index = state.items.indexOf(invoice[0]);
        state.items.splice(index, 1);
    },
    setSearchFilterObj(state, ui) {
        state.searchFilterObj = ui;
    },
    setTokensNew(state, ui) {
        state.tokens = ui
    },
    setToken(state, ui) {
        state.token.splice(0, state.token.length);
        _.forEach(ui, itm => {
            state.token.push(itm)
        })
    },
    setTokens(state, ui) {
        for (let key in state.tokens) {
            delete state.tokens[key]
        }
        for (let key in ui) {
            state.tokens[key] = ui[key];
        }
    },
    setSortByForInvoicesAll(state, ui) {
      state.sortByForInvoicesAll = ui;
    },
    setSortDescForInvoicesAll(state, ui) {
        state.sortDescForInvoicesAll = ui;
    },
    setSortByForInvoicesAwaitingPayment(state, ui) {
        state.sortByForInvoicesAwaitingPayment = ui;
    },
    setSortDescForInvoicesAwaitingPayment(state, ui) {
        state.sortDescForInvoicesAwaitingPayment = ui;
    },
    setSortByForInvoicesPaid(state, ui) {
        state.sortByForInvoicesPaid = ui;
    },
    setSortDescForInvoicesPaid(state, ui) {
        state.sortDescForInvoicesPaid = ui;
    },
    setInvoicesPerPage(state, ui) {
        state.invoicesPerPage = ui;
    },
    setInvoicesAllCurrentPage(state, ui) {
        state.invoicesAllCurrentPage = ui;
    },
    setInvoicesAwaitingPaymentCurrentPage(state, ui) {
        state.invoicesAwaitingPaymentCurrentPage = ui;
    },
    setInvoicesPaidCurrentPage(state, ui) {
        state.invoicesPaidCurrentPage = ui;
    },
    loadInvoices(state, ui) {
        // @invoice/mutations.js:61-79 (optimized)
        // Merge by id via Map to avoid O(N²) uniq/union work and reduce reactive allocations.
        const itemMap = new Map();
        const prev = state.items;
        for (let i = 0; i < prev.length; i++) {
            const inv = prev[i];
            const id = inv && inv.id != null ? Number(inv.id) : null;
            if (id != null && !Number.isNaN(id)) {
                inv.id = id;
                itemMap.set(id, inv);
            }
        }
        const next = ui || [];
        for (let i = 0; i < next.length; i++) {
            const inv = next[i];
            const id = inv && inv.id != null ? Number(inv.id) : null;
            if (id != null && !Number.isNaN(id)) {
                inv.id = id;
                itemMap.set(id, inv);
            }
        }
        const items = Array.from(itemMap.values());
        items.sort((a, b) => b.id - a.id);
        state.items = items;
        console.log('LOADED.loadInvoices')
    },
    setTimestamp(state, timestamp = 0) {
        console.log('timestamp', timestamp);
        state.timestamp = timestamp;
    },
    logout(state) {
        state.timestamp = 0;
        state.items = [];
    },
    invoicesUpdated (state, ui) {
      // @invoice/mutations.js:81-88 (optimized)
      // Merge updates by id via Map and keep items pre-sorted by id desc.
      const itemMap = new Map();
      const prev = state.items;
      for (let i = 0; i < prev.length; i++) {
        const inv = prev[i];
        const id = inv && inv.id != null ? Number(inv.id) : null;
        if (id != null && !Number.isNaN(id)) {
          inv.id = id;
          itemMap.set(id, inv);
        }
      }
      const next = ui || [];
      for (let i = 0; i < next.length; i++) {
        const inv = next[i];
        const id = inv && inv.id != null ? Number(inv.id) : null;
        if (id != null && !Number.isNaN(id)) {
          inv.id = id;
          itemMap.set(id, inv);
        }
      }
      const items = Array.from(itemMap.values());
      items.sort((a, b) => b.id - a.id);
      state.items = items;
    }
}
